export const BEDROOM_LABELS = {
  STUDIO: "Studio",
  ONE_BEDROOM: "1",
  TWO_BEDROOMS: "2",
  THREE_BEDROOMS: "3",
  FOUR_OR_MORE_BEDROOMS: "4",
  ROOM_SHARED_HOME: "Shared Home",
  FIVE_BEDROOMS: "5",
  SIX_BEDROOMS: "6",
  SEVEN_BEDROOMS: "7",
  EIGHT_BEDROOMS: "8",
  NINE_BEDROOMS: "9",
  TEN_BEDROOMS: "10",
}
